import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  IonCol,
  IonGrid,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/angular/standalone';
import { DecaCompanyStoreService } from '../deca-company-store.service';

@Component({
  selector: 'lib-deca-contact-book-list',
  templateUrl: './deca-contact-book-list.component.html',
  styleUrls: ['./deca-contact-book-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonCol, IonRow, IonGrid, IonItem, IonLabel, IonItemDivider, IonItemGroup, IonList],
})
export class DecaContactBookListComponent {
  private readonly decaCompanyStoreService = inject(DecaCompanyStoreService);

  /** The store keeps the last loaded companies, so a failed reload does not empty the list. */
  protected readonly companies = this.decaCompanyStoreService.companies;
}
